export const formatDurationTime = (duration: number, short?: boolean) => {
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    if (short)
        return `${hours === 0 ? '' : hours > 1 ? `${hours} hrs` : `${hours} hr`} ${minutes > 0 ? `${minutes} mins` : ''}`;
    return `${hours === 0 ? '' : hours > 1 ? `${hours} hours` : `${hours} hour`} ${minutes > 0 ? `${minutes} minutes` : ''}`;
};
